import React from 'react';
import { X } from 'phosphor-react';
import { Modal } from '@material-ui/core';
import { CheckmarkBlob } from '../../../../utility/Icons';
import {
  closePreapprovedContactModal,
  setLenderIntroductionComplete,
} from '../../../../../actions/dashboard';
import styles from '../../../../../styles/sass/components/GetPreapproved.module.scss';
import { connect } from 'react-redux';

interface Props {
  modalStyle: any;
  showPreapprovedContactModal: any;
  dispatch: Function;
}

export const ContactModal: React.FC<Props> = ({
  modalStyle,
  showPreapprovedContactModal,
  dispatch,
}) => {
  const handleComplete = () => {
    dispatch(setLenderIntroductionComplete());
    dispatch(closePreapprovedContactModal());
  };

  return (
    <Modal
      open={showPreapprovedContactModal}
      onClose={() => dispatch(closePreapprovedContactModal())}
      style={modalStyle}
    >
      <div className={styles.contactContainer}>
        <div className={styles.header}>
          <CheckmarkBlob
            width="66"
            height="60"
            style={{ margin: '24px 0 0 24px' }}
          />
          <button
            className={styles.closePhoto}
            onClick={() => {
              dispatch(closePreapprovedContactModal());
            }}
          >
            <X size={32} color="#323232" weight="regular" />
          </button>
        </div>
        <div className={styles.body}>
          <p className={styles.mainText}>We will be in contact soon</p>
          <p className={styles.subText}>
            Our lender/team will email you with next steps
          </p>
        </div>
        <div className={styles.buttonContainer}>
          <button className={styles.button} onClick={handleComplete}>
            Cool!
          </button>
        </div>
      </div>
    </Modal>
  );
};

const mapStateToProps = (state: any) => ({
  showPreapprovedContactModal: state.dashboard.showPreapprovedContactModal,
});

export default connect(mapStateToProps)(ContactModal);
